import PonudjeniOdgovor from "./PonudjeniOdgovorKorisnik";
import { useState, useEffect} from "react";
import "./Pitanje.css";
import { Input } from "antd";
const { TextArea } = Input;

const PitanjeKorisnik = ({ pitanje, onPromjenaOdgovora, trenutniOdgovori }) => {
  const [tekstOdgovora, setTekstOdgovora] = useState("");

   useEffect(() => {
    if (trenutniOdgovori[pitanje.id]) {
      setTekstOdgovora(trenutniOdgovori[pitanje.id]);
    }
  }, [pitanje.id, trenutniOdgovori]);


  const handleOdgovorChange = ({ pitanjeId, tekstOdgovora, checked }) => {
  onPromjenaOdgovora(pitanjeId, tekstOdgovora, checked, pitanje.tip);
};
   const handleBlur = () => {
    onPromjenaOdgovora(pitanje.id, tekstOdgovora);
  };

  return (
    <div className="pitanje-card">
      <h4 className="tekst-pitanja">
        <span className="obavezno-zvezdica">
          {pitanje.obavezno ? "*" : "\u00A0"}
        </span>
        <span className="tekst-broj">{pitanje.pozicija}.</span>
        <span className="tekst-tekst">{pitanje.tekstPitanja}</span>
      </h4>

      {pitanje.objasnjenje && (
        <h5 className="pitanje-objasnjenje">{pitanje.objasnjenje}</h5>
      )}

      {pitanje.tip === "TEKSTUALNO" ? (
        <TextArea
          type="text"
          placeholder="Unesite odgovor"
          className="pitanje-input"
          value={tekstOdgovora}
          onChange={(e) => setTekstOdgovora(e.target.value)}
          onBlur={handleBlur} 
        />
      ) : (
        <div className="odgovori-lista">
          {pitanje.ponudjeniOdgovori
            .sort((a, b) => a.pozicija - b.pozicija)
            .map((odg) => (
              <PonudjeniOdgovor
                key={odg.id}
                odgovor={odg}
                tip={pitanje.tip}
                onOdgovorChange={handleOdgovorChange}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export default PitanjeKorisnik;
